import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { BlocksDispenser } from "./BlocksDispenser";
import { BoardContainer } from "./BoardContainer";
import { BoardManager } from "./BoardManager";
import { Niche } from "./niche/Niche";
import * as Templok from "@ravalmatic/templok-engine";

export class Block extends Phaser.GameObjects.Container {

    public static readonly SCALE_ON_DISPENSER = .34;

    public blockData: Templok.BlockData;
    public color: number;
    public isOnNiche: boolean;
    public dragging: boolean;
    public px: number;
    public py: number;
    public blockWidth: number;
    public blockHeight: number;
    public enabled: boolean;

    private squares: Phaser.GameObjects.Image[];
    private squaresOff: Phaser.GameObjects.Image[];
    private blocksDispenser: BlocksDispenser;
    private dx: number;
    private tweening: boolean;
    private handCursor: Phaser.GameObjects.Image;
   
    constructor(scene: Phaser.Scene, blocksDispenser: BlocksDispenser, blockData: Templok.BlockData, color: number, px: number, py: number, reRollOrRotationBlock?: boolean) {
        
        super(scene);

        this.blocksDispenser = blocksDispenser;
        this.blockData = blockData;
        this.color = color;
        this.px = px;
        this.py = py;
        this.enabled = true;
        this.dragging = false;
        this.isOnNiche = false;
        this.squares = [];
        this.squaresOff = [];
        this.tweening = false;
        this.handCursor = null;

        let minCol = 5;
        this.blockWidth = 0;
        this.blockHeight = 0;

        const data = this.blockData.data[this.blockData.i];

        // EL CASO DEL BLOQUE ALARGADO DE 5 CELDAS
        if (data === 0x0001 || data === 0x0002) {

            for (let i = 0; i < 5; i++) {

                let square: Phaser.GameObjects.Image;
                let squareOff: Phaser.GameObjects.Image;

                if (data === 0x0001) {
                    square = new Phaser.GameObjects.Image(this.scene, BoardContainer.CELL_SIZE * i, 0, "texture_atlas_1", "gem_0" + this.color);
                    
                    this.blockWidth = 5;
                    this.blockHeight = 1;

                    squareOff = new Phaser.GameObjects.Image(this.scene, BoardContainer.CELL_SIZE * i, 0, "texture_atlas_1", "gem_00");
                } else {
                    square = new Phaser.GameObjects.Image(this.scene, 0, BoardContainer.CELL_SIZE * i, "texture_atlas_1", "gem_0" + this.color);
                    
                    this.blockWidth = 1;
                    this.blockHeight = 5;

                    squareOff = new Phaser.GameObjects.Image(this.scene, 0, BoardContainer.CELL_SIZE * i, "texture_atlas_1", "gem_00");
                }

                square.setInteractive();
                square.on("pointerdown", this.onDown, this);
                this.add(square);

                this.squares.push(square);

                squareOff.visible = false;
                squareOff.setInteractive();
                squareOff.on("pointerdown", this.onDown, this);
                
                this.add(squareOff);
        
                this.squaresOff.push(squareOff);
            }

            minCol = 0;

        } else {

            for (let c = 0; c < 4; c++) {
                for (let r = 0; r < 4; r++) {
                    if (data & (0x8000 >> (c * 4 + r))) {

                        const square = new Phaser.GameObjects.Image(this.scene, BoardContainer.CELL_SIZE * c, BoardContainer.CELL_SIZE * r, "texture_atlas_1", "gem_0" + this.color);
                        square.setInteractive();
                        square.on("pointerdown", this.onDown, this);
                        this.add(square);

                        this.squares.push(square);
    
                        // ENCONTRAR LA CELDA EN LA LINEA 0 CON LA COLUMNA MAS BAJA
                        if (r === 0 && c <= minCol) {
                            minCol = c;
                        }

                        if (c >= this.blockWidth) {
                            this.blockWidth = c;
                        }

                        if (r + 1 >= this.blockHeight) {
                            this.blockHeight = r + 1;
                        }

                        const squareOff  = new Phaser.GameObjects.Image(this.scene, BoardContainer.CELL_SIZE * c, BoardContainer.CELL_SIZE * r, "texture_atlas_1", "gem_00");
                        squareOff.visible = false;
                        squareOff.setInteractive();
                        squareOff.on("pointerdown", this.onDown, this);
    
                        this.add(squareOff);

                        this.squaresOff.push(squareOff);
                    }
                }
            }

            this.blockWidth ++;
        }

        this.dx = minCol * BoardContainer.CELL_SIZE;
        
        this.px -= (this.blockWidth - 1) * BoardContainer.CELL_SIZE / 2 * Block.SCALE_ON_DISPENSER;
        this.py -= (this.blockHeight - 1) * BoardContainer.CELL_SIZE / 2 * Block.SCALE_ON_DISPENSER;

        this.x = this.px;
        this.y = reRollOrRotationBlock ? this.py : this.py + 25; // estos 25 son para el tween de aparicion

        this.setScale(reRollOrRotationBlock ? Block.SCALE_ON_DISPENSER : Block.SCALE_ON_DISPENSER * .95);

        if (GameConstants.DEBUG_MODE) {
            this.drawDebugGraphics();
        }
    }

    public update(): void {

        if (this.dragging) {

            const blocksDispenser = <BlocksDispenser> this.parentContainer;
            const boardContainer = <BoardContainer> blocksDispenser.parentContainer;

            let x = this.scene.input.activePointer.x;
            let y = (this.scene.input.activePointer.y - GameConstants.GAME_HEIGHT * .45) / GameVars.scaleY;

            x = x - boardContainer.x - this.dx;
            y = y - blocksDispenser.y;

            if (!GameVars.isDesktop) {
                y -= (this.blockHeight + .5) * BoardContainer.CELL_SIZE;
            }

            this.x += (x - this.x) * .35;
            this.y += (y - this.y) * .35;

            if (!this.isOnNiche && this.isOverNiche()) {
                Niche.currentInstance.activateGlow();
            } else {
                Niche.currentInstance.deactivateGlow();
            }

        } else if (!this.tweening) {

            this.x = this.px;
            this.y = this.py;
            this.setScale(Block.SCALE_ON_DISPENSER);
        }
    }

    public appear(i: number): void {

        this.alpha = 0;
        this.tweening = true;

        this.scene.tweens.add({
            targets: this,
            y: this.py,
            scaleX: Block.SCALE_ON_DISPENSER,
            scaleY: Block.SCALE_ON_DISPENSER,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450,
            delay: 150 + 150 * i,
            onComplete: function(): void {
                this.tweening = false;
            },
            onCompleteScope: this
        });
    }

    public enable(): void {

        if (this.enabled) {
            return;
        }

        this.enabled = true;

        this.squares.forEach(function(square) {
            square.visible = true;
            square.alpha = 0;
        });

        this.scene.tweens.add({
            targets: this.squares,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450
        });

        this.scene.tweens.add({
            targets: this.squaresOff,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450,
            onComplete: function(): void {
                this.squaresOff.forEach(function(squareOff) {
                    squareOff.visible = false;
                });
            },
            onCompleteScope: this
        });
    }

    public disable(): void {

        if (!this.enabled) {
            return;
        }

        this.enabled = false;

        this.squaresOff.forEach(function(squareOff) {
            squareOff.visible = true;
            squareOff.alpha = 0;
        });

        this.scene.tweens.add({
            targets: this.squaresOff,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450
        });

        this.scene.tweens.add({
            targets: this.squares,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 450,
            onComplete: function(): void {
                this.squares.forEach(function(square) {
                    square.visible = false;
                });
            },
            onCompleteScope: this
        });
    }

    // TODO: REFACTORIZAR ESTAS 2 FUNCIONES returnToOrigin y goToNiche
    public returnToOrigin(): void {
        
        this.dragging = false;
        this.tweening = true;

        for (let i = 0; i < this.squares.length; i ++) {
            this.squares[i].setScale(1);
        }

        const distanceToOrigin = Math.sqrt((this.x - this.px) * (this.x - this.px) + (this.y - this.py) * (this.y - this.py));
        const t = distanceToOrigin * .95;

        this.scene.tweens.add({
            targets: this,
            x: this.px,
            y: this.py,
            scaleX: Block.SCALE_ON_DISPENSER,
            scaleY: Block.SCALE_ON_DISPENSER,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: t,
            onComplete: function(): void {
                this.tweening = false;
            },
            onCompleteScope: this
        });
    }

    public goToNiche(restoredGameBlock?: boolean): void {

        this.dragging = false;
        this.isOnNiche = true;
        
        for (let i = 0; i < this.squares.length; i ++) {
            this.squares[i].setScale(1);
        }

        const distanceToOrigin = Math.sqrt(this.x * this.x + this.y * this.y);
        const t = distanceToOrigin * .95;

        this.px = -(this.blockWidth - 1) * BoardContainer.CELL_SIZE / 2 * Block.SCALE_ON_DISPENSER;
        this.py = -(this.blockHeight - 1) * BoardContainer.CELL_SIZE / 2 * Block.SCALE_ON_DISPENSER;

        if (restoredGameBlock) {

            this.x = this.px;
            this.y = this.py;

        } else {

            this.tweening = true;
            this.scene.tweens.add({
                targets: this,
                x: this.px,
                y: this.py,
                scaleX: Block.SCALE_ON_DISPENSER,
                scaleY: Block.SCALE_ON_DISPENSER,
                ease: Phaser.Math.Easing.Cubic.Out,
                duration: t,
                onComplete: function (): void {
                    this.tweening = false;
                },
                onCompleteScope: this
            });
        }
    }

    public removeFakeBlockFromNiche(): void {

        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 350,
            onComplete: () => {
                this.destroy();
            },
            onCompleteScope: this
        });
    }

    public onPointerUp(): void {

        if (this.handCursor) {
            this.handCursor.destroy();
        }       

        this.dragging = false;

        for (let i = 0; i < this.squares.length; i ++) {
            this.squares[i].setScale(1);
        }

        if (this.isOverNiche()) { 

            if (GameVars.templokEngine.blockOnNicheData) {
                BoardManager.currentInstance.onBlockNotFitting(false);
            } else {
                BoardManager.currentInstance.onBlockReleasedOnNiche(); 
            }
    
        } else {

            const p = this.getPositionOnBoard();

            if (p.c >= 0 && p.c < Templok.Engine.GRID_SIZE && p.r >= 0 && p.r <  Templok.Engine.GRID_SIZE) {
                BoardManager.currentInstance.onBlockReleased(p);
            } else {
                BoardManager.currentInstance.onBlockNotFitting(p.r > 0);
            } 
        }
    }

    public getPositionOnBoard(): {c: number, r: number} {

        const blocksDispenser = <BlocksDispenser> this.parentContainer;

        const x = this.x + blocksDispenser.x;
        const y = this.y + blocksDispenser.y;

        const c = Math.round (x / BoardContainer.CELL_SIZE + (Templok.Engine.GRID_SIZE / 2 - .5));
        const r = Math.round (y / BoardContainer.CELL_SIZE + (Templok.Engine.GRID_SIZE / 2 - .5));

        return {c: c, r: r};
    }

    public onRotation(): void {

        const rotatedSquares: Phaser.GameObjects.Image [] = [];

        for (let i = 0; i < this.squares.length; i ++) {

            const px =  this.squares[i].x;
            const py =  this.squares[i].y;
            const rotatedSqare = new Phaser.GameObjects.Image(this.scene, px, py, "texture_atlas_1", "gem_0" + this.color);
            rotatedSqare.angle = -90;
            rotatedSqare.alpha = 0;
            this.add(rotatedSqare);

            rotatedSquares.push(rotatedSqare);
        }

        this.scene.tweens.add({
            targets: rotatedSquares,
            alpha: 1,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: Niche.ROTATION_TIME,
            onComplete: function(): void {
                for (let i = 0; i < this.squares.length; i ++) {
                    this.squares[i].destroy();
                }
                this.squares = rotatedSquares;
            }, 
            onCompleteScope: this
        });
    }

    public moveReplayBlockToBoard(p: {c: number, r: number}): void {
        
        if (this.isOnNiche) {
            this.x += this.blocksDispenser.niche.x;
            this.y += this.blocksDispenser.niche.y;
            this.parentContainer.remove(this);
            this.blocksDispenser.add(this);
        }

        this.blocksDispenser.bringToTop(this);

        const x = (p.c - Templok.Engine.GRID_SIZE * .5 + .5) * BoardContainer.CELL_SIZE - this.blocksDispenser.x;
        const y = (p.r - Templok.Engine.GRID_SIZE * .5 + .5) * BoardContainer.CELL_SIZE - this.blocksDispenser.y;

        const d = (this.x - x) * (this.x - x) + (this.y - y) * (this.y - y);
        let t = d / 750;
        
        if (t < 300) {
            t = 250;
        }
        
        this.tweening = true;

        this.scene.tweens.add({
            targets: this,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250,
            onComplete: function(): void {
                this.scene.tweens.add({
                    targets: this,
                    x: x,
                    y: y,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: t,
                    onComplete: function(): void {
                        this.onPointerUp();
                        this.tweening = false;
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });

        this.handCursor = new Phaser.GameObjects.Image(this.scene, -BoardContainer.CELL_SIZE + this.dx, BoardContainer.CELL_SIZE / 2, "texture_atlas_1", "hand_cursor");
        this.handCursor.setOrigin(-.1);
        this.handCursor.angle = -30;
        this.add(this.handCursor);
    }

    public moveReplayBlockToNiche(): void {

        this.blocksDispenser.bringToTop(this);
        
        // la posicion del punto medio de la pieza
        const x = this.blocksDispenser.niche.x - (this.blockWidth  - 1) / 2 * BoardContainer.CELL_SIZE;
        const y = this.blocksDispenser.niche.y - (this.blockHeight  - 1) / 2 * BoardContainer.CELL_SIZE;

        const d = (this.x - x) * (this.x - x) + (this.y - y) * (this.y - y);
        let t = d / 500;

        if (t < 350) {
            t = 350;
        }

        this.scene.tweens.add({
            targets: this,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250,
            onComplete: function(): void {
                this.scene.tweens.add({
                    targets: this,
                    x: x,
                    y: y,
                    ease: Phaser.Math.Easing.Cubic.Out,
                    duration: t,
                    onComplete: function(): void {
                        this.onPointerUp();
                    },
                    onCompleteScope: this
                });
            },
            onCompleteScope: this
        });

        this.handCursor = new Phaser.GameObjects.Image(this.scene, -BoardContainer.CELL_SIZE / 2, BoardContainer.CELL_SIZE / 2, "texture_atlas_1", "hand_cursor");
        this.handCursor.setOrigin(0);
        this.handCursor.angle = -30;
        this.add(this.handCursor);
    }

    private onDown(): void {

        if (GameVars.gameOver || GameVars.paused || GameVars.reRolling || this.tweening || this.dragging || (!this.enabled && GameVars.templokEngine.blockOnNicheData) || GameVars.doingCombo) {
            return;
        }

        this.dragging = true;
        this.tweening = true;

        if (this.blocksDispenser.handCursor) {
            this.blocksDispenser.removeHandCursor();
        }

        for (let i = 0; i < this.squares.length; i ++) {
            this.squares[i].setScale(.9);
        }

        this.scene.tweens.add({
            targets: this,
            scaleX: 1,
            scaleY: 1,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 200,
            onComplete: function(): void {
                this.tweening = false;
            },
            onCompleteScope: this
        });

        if (this.isOnNiche) {
            this.x += this.blocksDispenser.niche.x;
            this.y += this.blocksDispenser.niche.y;
            this.parentContainer.remove(this);
            this.blocksDispenser.add(this);
        }

        this.blocksDispenser.bringToTop(this);
       
        BoardManager.currentInstance.onBlockSelected(this);

        AudioManager.playSound("piece_clicked");
    }

    private drawDebugGraphics(): void {

        const debugGraphics = new Phaser.GameObjects.Graphics(this.scene);
        debugGraphics.x = -BoardContainer.CELL_SIZE * .5;
        debugGraphics.y = -BoardContainer.CELL_SIZE * .5;
        this.add(debugGraphics);

        debugGraphics.lineStyle(2, 0xFFFFFF, 1);

        debugGraphics.moveTo(0, 0);
        debugGraphics.lineTo(this.blockWidth * BoardContainer.CELL_SIZE, 0);

        debugGraphics.moveTo(this.blockWidth * BoardContainer.CELL_SIZE, 0);
        debugGraphics.lineTo(this.blockWidth * BoardContainer.CELL_SIZE, this.blockHeight * BoardContainer.CELL_SIZE);

        debugGraphics.moveTo(this.blockWidth * BoardContainer.CELL_SIZE, this.blockHeight * BoardContainer.CELL_SIZE);
        debugGraphics.lineTo(0, this.blockHeight * BoardContainer.CELL_SIZE);

        debugGraphics.moveTo(0, this.blockHeight * BoardContainer.CELL_SIZE);
        debugGraphics.lineTo(0, 0);

        debugGraphics.stroke();

        const idLabel = new Phaser.GameObjects.Text(this.scene, -BoardContainer.CELL_SIZE, -BoardContainer.CELL_SIZE, this.blockData.id.toString(), {fontFamily: "Arial", fontSize: "42px", color: "#FFFFFF"});
        this.add(idLabel);
    }

    private isOverNiche(): boolean {

        const niche_x = this.blocksDispenser.niche.x;
        const niche_y = this.blocksDispenser.niche.y;
        const niche_r = BlocksDispenser.NICHE_R;

        // la posicion del punto medio de la pieza
        const px = this.x + (this.blockWidth  - 1) / 2 * BoardContainer.CELL_SIZE;
        const py = this.y + (this.blockHeight  - 1) / 2 * BoardContainer.CELL_SIZE;

        const d = Math.sqrt((px - niche_x) * (px - niche_x) + (py - niche_y) * (py - niche_y));

        return d <= niche_r;
    }
}
